module.exports = __webpack_public_path__ + "static/media/slide1.162e0a98.webp";